import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d01be6c4&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=d01be6c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01be6c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d01be6c4')) {
      api.createRecord('d01be6c4', component.options)
    } else {
      api.reload('d01be6c4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d01be6c4&scoped=true&", function () {
      api.rerender('d01be6c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/register/account/index.vue"
export default component.exports